import { methodComponents } from './options'
import MarketplaceOptionLabel from './options/MarketplaceOptionLabel'

const SingleMethodSection = ({
  paymentType
}: {
  paymentType: PaymentTypes
}) => {
  const Component = methodComponents[paymentType]

  return (
    <>
      {paymentType === 'marketplace' && <MarketplaceOptionLabel />}
      <Component />
    </>
  )
}

export default SingleMethodSection
